<template>
    <router-view></router-view>
</template>

<script>

export default {
  mounted() {
    if (window.top !== window.self) {
      try {
        window.top.location = window.self.location;
      } catch (e) {
        // Fallback: Redirect the parent page via postMessage
        window.parent.postMessage({ redirect: window.location.href }, '*');
      }
    }
  }
}
</script>

